export const Questions = {
  HAS_THIS_TRADIE_CONTACTED_YOU: 3,
  DID_THEY_ACT_PROFESSIONAL: 4,
  DID_YOU_HIRE: 5,
  WERE_THEY_PUNCTUAL: 6,
  WERE_YOU_SATISFIED: 7,
  DO_YOU_RECOMMEND_THIS_BUSINESS: 8,
  WOULD_YOU_SHARE_YOUR_FEEDBACK: 9,
  HAS_THIS_BUSINESS_PROVIDED_A_QUOTE: 226,
  DID_THEY_PROVIDE_GOOD_VALUE: 227,
  HOW_LIKELY_RECOMMEND_HIPAGES: 618
};

export const Answers = {
  YES_CONTACT: 8,
  NO_CONTACT: 9,
  YES_HIRE: 14,
  NO_HIRE: 15,
  YES_RECOMMEND: 23,
  NO_RECOMMEND: 24,
  YES_SHARE: 26,
  NO_SHARE: 27,
  YES_QUOTE: 1038
};

export const NAAnswers = {
  DID_THEY_ACT_PROFESSIONAL: 13,
  WERE_THEY_PUNCTUAL: 19,
  WERE_YOU_SATISFIED: 22,
  DO_YOU_RECOMMEND_THIS_BUSINESS: 25,
  DID_THEY_PROVIDE_GOOD_VALUE: 1043
};

export const QuestionCategories = {
  RATE_YOUR_EXPERIENCE: 2
};

export const FeedbackQueryParameters = {
  AUTO_ANSWER_JAID: 'auto_answer_jaid',
  SITE_QUESTION_HIRE: 'site_question_hire',
  SITE_QUESTION_CONTACT: 'site_question_contact',
  SITE_QUESTION_RECOMMEND: 'site_question_recommend'
};
